var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinityHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29312",
    "data-name": "Group 29312",
    transform: "translate(-1246 11448.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1246 -11448.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_4_",
    "data-name": "svgexport-17 (4)",
    transform: "translate(1262 -11436.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49765",
    "data-name": "Path 49765",
    d: "M17.028,131.4a1.915,1.915,0,0,1-3.268,1.354L12.406,131.4h0l-1.593.841-.673,1.426,1.366,1.367a5.139,5.139,0,0,0,8.772-3.634l-1.683-.715ZM0,131.4a5.139,5.139,0,0,1,8.772-3.634l1.366,1.366-.5,1.636-1.762.631h0l-1.353-1.354A1.914,1.914,0,0,0,3.25,131.4l-1.651.421Z",
    transform: "translate(0 -126.259)",
    fill: "#0089de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49766",
    "data-name": "Path 49766",
    d: "M207.923,131.4a1.914,1.914,0,0,0-3.268-1.354L203.3,131.4h0l-2.855.841-1.678-.841,2.267-2.267,1.366-1.366a5.139,5.139,0,0,1,8.772,3.634Z",
    transform: "translate(-190.895 -126.26)",
    fill: "#2ad7f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49767",
    "data-name": "Path 49767",
    d: "M7.872,256l-1.354,1.354A1.914,1.914,0,0,1,3.25,256H0a5.139,5.139,0,0,0,8.772,3.634l1.366-1.367L12.405,256Z",
    transform: "translate(0 -250.861)",
    fill: "#29b0ea"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityHighlighted);
export default __webpack_public_path__ + "static/media/infinityHighlighted.e994bf23664b725de1b6fc1838676c6a.svg";
export { ForwardRef as ReactComponent };